import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageTitle from '../../components/PageTitle';
import CommunityAvailabilitySidebar from '../CommunityAvailabilitySidebar';
import HighschoolRepVisitsButton from './HighschoolRepVisitsButton';
import createService from './embedService';
import { withFreemiumPropQuery } from '../../utils/features';
import { MATCHING_SUBSCRIPTION } from '../Authorization/constants';
import { logout } from '../Authorization/actions';

export class CounselorCommunityServerlessApp extends React.PureComponent {
  static propTypes = {
    freemium: PropTypes.bool,
    activeSubscriptions: PropTypes.array,
    signOut: PropTypes.func,
    current: PropTypes.shape({
      viewer: PropTypes.object,
    }),
  }

  static defaultProps = {
    activeSubscriptions: [],
  };

  state = {
    availabilitySidebarSchoolId: null,
  }

  showAvailabilitySideBar = (schoolId) => this.setState({ availabilitySidebarSchoolId: schoolId });

  hideAvailabilitySideBar = () => this.setState({ availabilitySidebarSchoolId: null });

  highschoolRepVisitsButton = (props) => (
    <HighschoolRepVisitsButton
      {...props}
      showAvailabilitySideBar={this.showAvailabilitySideBar}
    />
  );

  signOut = () => {
    this.props.signOut(this.props.current.viewer);
  }

  render() {
    const CounselorCommunity = global.CounselorCommunity?.default?.default;
    const { freemium, activeSubscriptions } = this.props;
    const isFreemium = freemium || !activeSubscriptions.includes(MATCHING_SUBSCRIPTION);
    return (
      <div className="counselor-community-serverless-container">
        <PageTitle title="Counselor Community" category="Awareness" />
        {CounselorCommunity ? (
          <CounselorCommunity
            freemium={isFreemium}
            embedService={createService(this.props)}
            baseUrl={process.env.COUNSELOR_COMMUNITY_API}
            HighschoolRepVisitsButton={this.highschoolRepVisitsButton}
            signOut={this.signOut}
          />
        ) : null}
        <CommunityAvailabilitySidebar
          visible={!!this.state.availabilitySidebarSchoolId}
          schoolId={this.state.availabilitySidebarSchoolId}
          closeFunction={this.hideAvailabilitySideBar}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  current: state.current,
});

const CounselorCommunityServerlessWithFreemium = withFreemiumPropQuery(CounselorCommunityServerlessApp);
export default connect(mapStateToProps, { logout })(CounselorCommunityServerlessWithFreemium);
